/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import { INPUT } from 'apmui/components/form/Model';
import { ResourceLoader, WARNING, ERROR, IResourceMap, RESOURCE_LIST_URL } from 'apmui/resource/ResourceLoader';
import { FORM_ID, FIELD_NAME } from './Model';
import { putResources } from 'apmui/resource/ResourceStore';

const app = App.get();

app.subscribeDefault(EventTags.CONFIGURE, (event, store) => {
    if (store.pageType !== 'oauthAuthz') {
        return;
    }
    store[store.pageType].form = {
        id: FORM_ID,
        title: '',
        submitCaption: '',
        method: 'POST',
        fields: [
            {
                name: FIELD_NAME,
                type: INPUT.HIDDEN,
                caption: '',
                disabled: false,
                value: undefined,
            },
        ],
    };
});

app.subscribeDefault(EventTags.START, (event, store) => {
    if (store.pageType !== 'oauthAuthz') {
        return;
    }
    // load resources
    const resourceLoader = new ResourceLoader();
    resourceLoader.onComplete = (resourceMap: IResourceMap, warning?: WARNING) => {
        app.dispatch(EventTags.RESOURCE_LOADING_COMPLETE, { resourceMap, warning });
    };
    resourceLoader.onFailure = (error: ERROR) => {
        app.dispatch(EventTags.RESOURCE_LOADING_FAILED, { error });
    };
    resourceLoader.load(RESOURCE_LIST_URL.OAUTH);
});

app.subscribe(EventTags.RESOURCE_LOADING_FAILED, (event, store) => {
    if (store.pageType !== 'oauthAuthz') {
        return;
    }
    const page = store[store.pageType];

    page.error = page.strings.loadingFailedError;
});

app.subscribe(EventTags.RESOURCE_LOADING_COMPLETE, (event, store) => {
    if (store.pageType !== 'oauthAuthz') {
        return;
    }
    const pagetype = store[store.pageType];

    if (!pagetype.resources) {
        pagetype.resources = {};
    }
    putResources(pagetype.resources, event.detail.resourceMap);
    if (event.detail.warning === WARNING.RESOURCE_INFO_MISSING_RESOURCES) {
        pagetype.warning = pagetype.strings.loadingIncompleteWarning;
    }
});
